import React from "react";

class ManageParent extends React.Component {
  render() {
    return <div></div>;
  }
}
export default ManageParent;
